export default class Controller {

	static get $inject(){
		return [
			'$state',
			'me',
			'AccountService'
		];
	}


	constructor($state,
	            me,
	            AccountService){

		this._AccountService = AccountService;
		this.item = me.data
	}

	submit(){
		this._AccountService.update(this.item);
	}

}






/** WEBPACK FOOTER **
 ** ./src/main/account/settings/controller.js
 **/